module.exports = __webpack_public_path__ + "img/landingAbout.3d036075.png";